import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";
import QueryGlobalInterface from "../../../interfaces/queryInterface";

export interface useBuscarResultadosProps {
  idTipoTarefa: string;
}

export function useTiposResultadosTarefa(
  props: useBuscarResultadosProps & QueryGlobalInterface
) {
  const fetchData = async () => {
    const LISTAR_TIPOS_RESULTADOS_TAREFAS = `${leadsWebEnviroment}/mobile/tipos-resultados-tarefas/v1?IdTipoTarefa=${props?.idTipoTarefa}`;
    const response = await instance.get(LISTAR_TIPOS_RESULTADOS_TAREFAS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_tipos_resultados_tarefas"],
    refetchOnMount: false,
    enabled: true,
  });
  return query;
}
